document.addEventListener('DOMContentLoaded', function () {
  // Cache DOM elements
  const priceContainer = document.querySelector('.pro-price');
  const monthlyPrice = document.querySelector('.pro-monthly-price');
  const annualPrice = document.querySelector('.pro-annual-price');
  const monthlyDollar = document.querySelector('.monthly-dollar-sign');
  const annualDollar = document.querySelector('.annual-dollar-sign');
  const disclaimer = document.querySelector('.disclaimer');
  const monthlyButton = document.querySelector(
    '.pricing-switch .pricing-option:first-child'
  );
  const annualButton = document.querySelector(
    '.pricing-switch .pricing-option:last-child'
  );
  const proCardCTA = document.getElementById('pro_card_cta'); // Select the button
  const pricingCardPro = document.querySelector('.pricing-card.pro');

  // Call togglePricing function to default to annual pricing on page load
  togglePricing(true);

  // Attach event listeners
  monthlyButton.addEventListener('click', function () {
    togglePricing(false); // Switch to Monthly pricing
  });

  annualButton.addEventListener('click', function () {
    togglePricing(true); // Switch to Annual pricing
  });

  // Add event listener to the "pro_card_cta" button
  proCardCTA.addEventListener('click', function () {
    let productId;
    if (annualButton.classList.contains('active')) {
      productId = 1522; // Annual subscription
    } else {
      productId = 1521; // Monthly subscription
    }

    // Add the product to the cart
    addProductToCart(productId);
  });

  // Toggle pricing function
  function togglePricing(isAnnual) {
    if (isAnnual) {
      // Display annual price, adjust styles, and show disclaimer
      priceContainer.style.marginTop = '15px';
      priceContainer.style.marginBottom = '0';
      annualPrice.style.display = 'inline';
      annualDollar.style.display = 'inline';
      monthlyPrice.style.fontSize = '36px';
      monthlyPrice.style.lineHeight = '64px';
      monthlyDollar.style.fontSize = '20px';
      monthlyPrice.classList.add('line-through');
      disclaimer.style.display = 'block';

      // Update button states: set annual as active, monthly as inactive
      annualButton.classList.add('active');
      monthlyButton.classList.remove('active');

      pricingCardPro.classList.remove('monthly');
      pricingCardPro.classList.add('annual');
    } else {
      // Display monthly price, remove line-through, and hide annual elements
      priceContainer.style.marginTop = '30px';
      priceContainer.style.marginBottom = '10px';
      annualPrice.style.display = 'none';
      annualDollar.style.display = 'none';
      monthlyPrice.style.fontSize = '78px';
      monthlyPrice.style.lineHeight = '84px';
      monthlyDollar.style.fontSize = '40px';
      monthlyPrice.classList.remove('line-through');
      disclaimer.style.display = 'none';

      // Update button states: set monthly as active, annual as inactive
      monthlyButton.classList.add('active');
      annualButton.classList.remove('active');

      pricingCardPro.classList.remove('annual');
      pricingCardPro.classList.add('monthly');
    }
  }

  // Function to add product to cart
  function addProductToCart(productId) {
    // Implement the code to add the product to the cart
    // This could be an AJAX request or a page redirect, depending on your platform
    // Example using a page redirect:
    window.location.href = '/subscription/?add-to-cart=' + productId;
  }
});
